import _URL from '../../URL/index';
const axios = _URL.axios;
const limit = 15

export default {
    services: {
        updatePrifile: (user_id, role, type, body, token) => {
            if (role === type) {
                if (role === "admin") {
                    return axios(token).patch(`/profile/customers/${user_id}`, body);
                } else if (role === "company") {
                    return axios(token).patch(`/profile/companies/${user_id}`, body);
                } else {
                    return axios(token).patch(`/profile/operators/${user_id}`, body);
                }
            } else {
                return axios(token).patch(`/profile/users/${user_id}`, body);
            }
        },
        getProfileUser: (user_id, role, account_type, token) => {
            if (role === account_type) {
                if (role === "admin") {
                    return axios(token).get(`/customers/${user_id}`);
                } else if (role === "company") {
                    return axios(token).get(`/companies/${user_id}`);
                } else {
                    return axios(token).get(`/operators/${user_id}`);
                }
            } else {
                return axios(token).get(`/users/${user_id}`);
            }
        },
        getSettings: async(_id, token) => {
            return await axios(token).get(`/settings/suppliers/${_id}`);
        }
    }
}